import React, { memo }  from 'react';
import IconWrapper from '../IconWrapper';

const IconCheckmarkCircle = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#4abfad"} className={`checkmark-circle ${props.className}`} viewBox="1.661 1.661 16.678 16.678">
        <path d="m10 1.66666667c-4.6 0-8.33333333 3.73333333-8.33333333 8.33333333s3.73333333 8.3333333 8.33333333 8.3333333 8.3333333-3.7333333 8.3333333-8.3333333-3.7333333-8.33333333-8.3333333-8.33333333zm0 15.00000003c-3.675 0-6.66666667-2.9916667-6.66666667-6.6666667s2.99166667-6.66666667 6.66666667-6.66666667 6.6666667 2.99166667 6.6666667 6.66666667-2.9916667 6.6666667-6.6666667 6.6666667zm3.825-10.35000003-5.49166667 5.49166663-2.15833333-2.14999997-1.175 1.17499997 3.33333333 3.3333334 6.66666667-6.6666667z" />
    </IconWrapper>
);

export default memo(IconCheckmarkCircle);
